// JsFromRoutes CacheKey 99ffe170bf2fd9d76a56144e583837d2
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/broker/settings'),
}
